import React from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'

const confirmButtonStyles = {
  danger: 'bg-red-500 hover:bg-red-600 text-white',
  warning: 'bg-orange-500 hover:bg-orange-600 text-white',
  primary: 'bg-yellowcolor hover:bg-yellowcolor/90 text-black',
}

const ConfirmActionModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  loading = false,
  variant = 'primary',
  icon: Icon,
}) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[99999] backdrop-blur-md">
      <div className="bg-white dark:bg-dark rounded-lg shadow-lg w-full max-w-md p-4 relative">
        <button
          onClick={onClose}
          disabled={loading}
          className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 disabled:opacity-50"
        >
          <AiOutlineCloseCircle className="h-5 w-5" />
        </button>

        <div className="flex flex-col items-center text-center px-2">
          {Icon && (
            <div className="w-16 h-16 bg-yellow-main/10 rounded-full flex items-center justify-center mb-3">
              <div className="w-12 h-12 bg-yellowcolor/30 dark:bg-[#FEECB8] rounded-full flex items-center justify-center">
                <Icon className="h-6 w-6 text-gray-700 dark:text-gray-900" />
              </div>
            </div>
          )}

          <h2 className="text-xl font-bold mb-2 dark:text-white">{title}</h2>
          <p className="text-gray-600 text-sm dark:text-gray-400 mb-6">{message}</p>

          <div className="flex gap-4 w-full">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="flex-1 h-12 rounded-full border border-gray-300 dark:border-border-dark dark:text-white disabled:opacity-50"
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={loading}
              className={`flex-1 h-12 rounded-full disabled:opacity-50 ${confirmButtonStyles[variant] || confirmButtonStyles.primary}`}
            >
              {loading ? 'Please wait...' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfirmActionModal
